import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ExclamationCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/ExclamationCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ExclamationCircleTwoTone.displayName = 'ExclamationCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(ExclamationCircleTwoTone);